import { render, staticRenderFns } from "./TableBinnacle.vue?vue&type=template&id=48152ca7&"
import script from "./TableBinnacle.vue?vue&type=script&lang=js&"
export * from "./TableBinnacle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports